import type { ReactNode } from "react"

import { BrandWordmark } from "@/components/brand-wordmark"
import { Card, CardContent } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export function StatusPage({
  eyebrow,
  title,
  description,
  action,
  children,
  wordmark = true,
  className,
  "data-component": dataComponent = "status-page",
}: {
  eyebrow?: ReactNode
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  children?: ReactNode
  wordmark?: boolean
  className?: string
  "data-component"?: string
}) {
  return (
    <div
      className={cn("flex min-h-screen flex-col bg-background text-foreground", className)}
      data-component={dataComponent}
    >
      {wordmark ? (
        <div className="flex w-full justify-center px-4 pb-6 pt-8 md:px-6 md:pb-8 md:pt-10">
          <BrandWordmark size="md" tone="foreground" textClassName="text-[28px] leading-none md:text-[32px]" />
        </div>
      ) : null}
      <main className="flex flex-1 items-center justify-center p-4 md:p-6">
        <Card className="w-full max-w-lg">
          <CardContent className="space-y-5 pt-6">
            {eyebrow}
            <h1 className="font-brand-display text-[clamp(2rem,5vw,2.5rem)] font-normal leading-[1.15] tracking-tight text-foreground">
              {title}
            </h1>
            {description ? (
              <p className="max-w-prose text-sm leading-relaxed text-muted-foreground">{description}</p>
            ) : null}
            {action}
            {children}
          </CardContent>
        </Card>
      </main>
    </div>
  )
}
